import { atom } from 'recoil';
import type { IConfigProps } from '../../context/ConfigContext';

export const topConfigContextAtom = atom<IConfigProps | undefined>({
    key: 'topConfigContext',
    default: undefined
});
